import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { cakeShopTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const CakeShopTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])
    const workingSinceOption = checkboxData.workSinceOption;
    const popularFlavourOption = checkboxData.popularFlavourCake;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const specialtyCakeOption = checkboxData.specialtyCake;
    const cakesShapeOption = checkboxData.cakesShape;

    const formik = useFormik({
        initialValues: {
            price: Math.floor(merchant?.price * currency.value) || '',
            popularFlavourCake: merchant?.popularFlavourCake || [],
            areaOfWorking: merchant?.areaOfWorking || [],
            workingSince: merchant?.workingSince || [],
            specialtyCake: merchant?.specialtyCake || [],
            cakesShape: merchant?.cakesShape || [],
        },
        enableReinitialize: true,
        validationSchema: cakeShopTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values, price: Math.floor(values.price * currency.country_value) },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow` ,data,
                    {
                         headers: {
                    Authorization: `Bearer ${token}`,
                },
                    }
                );

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Popular Flavour</th>
                                                            <th style={{ width: '25%' }}>Serving Cities</th>
                                                            <th style={{ width: '25%' }}>Specialty</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <span key={index}>{item.value}</span>
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.popularFlavourCake
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.areaOfWorking
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.specialtyCake
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span>{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Cakes Shapes</th>
                                                            <th>price</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.cakesShape
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span>{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td><NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.price
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            /></td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Popular Flavour<span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={popularFlavourOption}
                                                            selected
                                                            value={formik.values.popularFlavourCake}
                                                            onChange={(popularFlavourCake) => formik.setFieldValue('popularFlavourCake', popularFlavourCake)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.popularFlavourCake && formik.errors.popularFlavourCake ? (
                                                            <div className="text-danger">{formik.errors.popularFlavourCake}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Serving Cities</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWorking}
                                                            onChange={(areaOfWorking) => formik.setFieldValue('areaOfWorking', areaOfWorking)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWorking && formik.errors.areaOfWorking ? (
                                                            <div className="text-danger">{formik.errors.areaOfWorking}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Speicalty</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={specialtyCakeOption}
                                                            selected
                                                            value={formik.values.specialtyCake}
                                                            onChange={(specialtyCake) => formik.setFieldValue('specialtyCake', specialtyCake)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.specialtyCake && formik.errors.specialtyCake ? (
                                                            <div className="text-danger">{formik.errors.specialtyCake}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Cakes Shape</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={cakesShapeOption}
                                                            selected
                                                            value={formik.values.cakesShape}
                                                            onChange={(cakesShape) => formik.setFieldValue('cakesShape', cakesShape)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.cakesShape && formik.errors.cakesShape ? (
                                                            <div className="text-danger">{formik.errors.cakesShape}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="" htmlFor="inlineFormInputGroup">Starting Price</label>
                                                    <div className="input-group mb-2">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="price"
                                                            placeholder='Starting Price'
                                                            value={formik.values.price}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.price && formik.errors.price ? (
                                                        <div className="text-danger">{formik.errors.price}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn text-white' style={{ backgroundColor: '#085f9a' }} type='submit'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default CakeShopTTK